import Api from '@/api/api.js'

export default {
    addBaseAssurance(data) {
        const promise = Api().post('/medicaments/base_assurance/store', data)
        return promise.then((response) => response.data)
    },

    getBaseAssurance(medicament_id) {
        const promise = Api().get('/medicaments/'+medicament_id+'/base_assurance')
        return promise.then(response => response.data)
    },

    deleteBaseAssurance(data) {
        const promise = Api().put('/medicaments/base_assurance/delete', data)
        return promise.then((response) => response.data)
    },
}